import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'

import {
    // HomeOutlined,
    RightOutlined,
    QuestionCircleOutlined,
    FilePdfOutlined,
    FileExcelOutlined,
    // MoneyCollectOutlined,
    // StockOutlined
} from '@ant-design/icons';

import { Button, Empty, Modal, Popconfirm, Space, Table, message } from 'antd';
// import { useHistory } from 'react-router';
import { useApi } from '../../Utils';
import Column from 'antd/lib/table/Column';

import { Document, Page, Text, View, StyleSheet, PDFViewer, Font } from '@react-pdf/renderer';
import calculateMenu from './calculateMenu';

// @ts-ignore
import ChanelFont from '../../Assets/Fonts/ABChanel-PB-SemiBold-S.ttf'
import axios from 'axios';
import { pad } from '../Accounting/ReportCatalogProducts';
import { useSelector } from 'react-redux';

interface OrderRowItem {
    id: number
    paOrderId: number
    orderId: string
    internalCode: string
    productId: number
    qty_ordered: string
    netPrice: number
    created_at: string
    updated_at?: string
}

interface OrderRow {
    id: number
    increment_id: string
    date: string
    storeId: number
    extras: string
    paymentPeriod: number
    created_at: string
    updated_at?: string
    dispatchCarrierName: string
    dispatchCarrierCode: string
    processed: string
    items: OrderRowItem[]
    code?: string
}

const ButtonAction = ({ cta, record, setMainLoading }: { cta: string | undefined, record: OrderRow, setMainLoading: Dispatch<SetStateAction<boolean>> }) => {
    // const history = useHistory()

    const nextState = new Map([
        ['Controlar con CC', null],
        ['Despachar', null],
        ['Seguimiento', null]
    ])

    const { fetch, data, errors, loading } = useApi<any>('get', `v3/lucatmi/ar/shippingMail/${record.increment_id}`, {
        onRequest: true,
        requiredToken: true
    })

    useEffect(() => {
        if (data?.success) {
            window.location.reload()
        }
    }, [data])

    useEffect(() => {
        if (errors?.length > 0) {
            for (const error of errors) {
                message.error(`Error: ${error.statusMessage}`)
            }
        }
    }, [errors])

    return <Popconfirm
        disabled={['Despachado', 'PickingParcialAnulado'].includes(`${record.processed}`)}
        title={`¿Estás seguro de ${cta?.toLocaleLowerCase()} la orden ${record.increment_id}?`}
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        placement='left'
        onConfirm={() => {
            const _next = nextState.get(cta ?? 'Liberar')
            console.log(_next)

            const _code = prompt('Código de seguimiento')
            fetch(`?code=${_code}`)
            setMainLoading(true)
            // if (_next) {
            // } else {
            //     // history.push(`/orders/${record.orderId}`)
            // }
        }}
        onCancel={() => {
            //
        }}
        okType={'danger'}
        okText='Si'
        cancelText='No'
    >
        <Button
            size='small'
            style={{
                minWidth: 128,
                textAlign: 'left'
            }}
            type={!['Despachado', 'PickingParcialAnulado'].includes(`${record.processed}`) ? 'primary' : undefined}
            icon={<RightOutlined />}
            onClick={() => {
                if (['Despachado', 'PickingParcialAnulado'].includes(`${record.processed}`)) {

                }
            }}
            disabled={false}
            loading={loading}
        >
            {cta}
        </Button>
    </Popconfirm>
}

function Orders({ isMobile, exposeSubMenu, setMainLoading }: any) {
    const { data, loading, fetch } = useApi<any>('get', 'v3/lucatmi/ar/list')

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 30,
        total: 0
    });

    const [records, setRecords] = React.useState<any[]>([])
    const [, setFilters] = React.useState<any>({})

    useEffect(() => {
        if (data?.status === 'success') {
            setPagination({
                current: data.orders.current_page,
                pageSize: data.orders.per_page,
                total: data.orders.total
            })
            setRecords(data.orders.data)
            setFilters(data.filters)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [message, setMessage] = useState('')

    const { permissions: _permissions, userInfo: { id_client } } = useSelector((state: any) => state)
    const permissions = _permissions as string[]
    // const { token } = useSelector((state: any) => state)

    useEffect(() => {
        if (!isModalOpen) {
            setMessage('')
        }
    }, [isModalOpen])

    // useEffect(() => {
    //     if (data?.status === 'success') {
    //         setRecords(data.orders.data)
    //         // setRecords(data.orders)
    //         // console.log(data.orders)
    //     }
    // }, [data])

    useEffect(() => {
        if (!!exposeSubMenu) {
            exposeSubMenu(calculateMenu(permissions, id_client))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissions, exposeSubMenu])

    useEffect(() => {
        setMainLoading(false)
    }, [setMainLoading])

    return (
        <div className="App">
            <div className="Orders">
                <div className="Wrapper">
                    <Table
                        dataSource={records}
                        loading={loading}
                        pagination={pagination}
                        onChange={(newPagination, localFilters, localSorter) => {
                            fetch({
                                page: newPagination.current,
                                pageSize: newPagination.pageSize,
                                filters: JSON.stringify(localFilters),
                                sorter: JSON.stringify(localSorter)
                            })
                        }}
                        rowKey="increment_id"
                        rowSelection={{
                            type: 'checkbox',
                            onChange: (selectedRowKeys: React.Key[], selectedRows: OrderRow[]) => {
                                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                            },
                            getCheckboxProps: (record: OrderRow) => ({
                                disabled: record.processed === '2', // Column configuration not to be checked
                                // name: record.name,
                            }),
                        }}
                        className='TableListAll'
                        size='small'
                        locale={{
                            emptyText: (
                                <Empty
                                    style={{ marginTop: '32px', marginBottom: '48px' }}
                                    description='No se han encontrado órdenes con los criterios de bùsqueda.'
                                >
                                </Empty>
                            )
                        }}
                        footer={() => <>Total de órdenes {records.length}</>}
                    >
                        <Column
                            title='Número'
                            dataIndex='increment_id'
                            key='increment_id'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.increment_id.localeCompare(b.increment_id)}
                        />
                        <Column
                            title='Fecha'
                            dataIndex='placed_at'
                            key='placed_at'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.placed_at.localeCompare(b.placed_at)}
                        />
                        <Column
                            title='Estado'
                            dataIndex='processed'
                            key='processed'
                            filters={[
                                { text: 'Liberado', value: "0" },
                                { text: 'Controlado', value: "1" },
                                { text: 'Despachado', value: "2" }
                            ]}
                            // defaultFilteredValue={["0", "1"]}
                            // defaultFilteredValue={['Liberado', 'Controlado']}
                            onFilter={(value, record: any) => {
                                if (value === '') {
                                    return record.processed === null
                                }
                                if (value === 'Anulado') {
                                    return record.processed === 'PickingParcialAnulado'
                                }
                                if (value === 'Picking') {
                                    return record.processed === 'PickingParcialCompletado' || record.lastState === 'PickingCompleto'
                                }

                                return record.lastState?.indexOf(value) > -1
                            }}
                            render={(value) => {
                                switch (value) {
                                    case '0':
                                        return <>Liberado</>
                                    case '1':
                                        return <>Controlado</>
                                    case '2':
                                        return <>Despachado</>
                                    default:
                                        return <>Por liberar</>
                                }
                            }}
                        />
                        <Column
                            title='Referencias'
                            key='products'
                            render={(value, record: OrderRow) => {
                                return <>{record.items.length}</>
                            }}
                        />
                        <Column
                            title='Unidades'
                            key='units'
                            render={(value, record: OrderRow) => {
                                return <>{record.items.reduce((acc, i) => {
                                    acc += Number(i.qty_ordered)
                                    return acc
                                }, 0)}</>
                            }}
                        />
                        <Column
                            title='Código Postal'
                            dataIndex={['address','fax']}
                            key='address.fax'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.date.localeCompare(b.date)}
                            render={(value, record: any) => {
                                const dictionary = new Map([
                                    ['NXD', '99minutos'],
                                    ['Entrega estándar', 'Starken']
                                ])
                                // (${record.dispatchCarrierCode})
                                if (dictionary.has(value)) {
                                    return `${dictionary.get(value)}`
                                }
                                return `${value}`
                            }}
                        />
                        <Column
                            title='Acciones'
                            key='action'
                            render={(text, record: OrderRow) => {
                                const actions = new Map([
                                    ["0", 'Despachar'],
                                    // ["0", 'Controlar con CC'],
                                    ['1', 'Despachar'],
                                    ['2', 'Seguimiento']
                                ])
                                const cta = actions.get(record.processed)

                                return <Space size='small'>
                                    {/* Action Button */}
                                    {cta !== "Seguimiento" && <ButtonAction
                                        cta={cta}
                                        record={record}
                                        key={`ButtonAction${record.id}`}
                                        setMainLoading={setMainLoading} />}
                                    {/* Excel eOC */}
                                    {false && <ButtonExcel disabled order={record} />}
                                    {/* Descarga PDF */}
                                    {record.extras !== null && <Button
                                        size='small'
                                        type={undefined}
                                        onClick={() => {
                                            setMessage(record.extras)
                                            setIsModalOpen(true)
                                        }}
                                        danger
                                        disabled
                                    >
                                        <FilePdfOutlined />Factura
                                    </Button>}
                                    {record.extras !== null && <Button
                                        size='small'
                                        type={undefined}
                                        onClick={() => {
                                            setMessage(record.extras)
                                            setIsModalOpen(true)
                                        }}
                                        danger
                                        disabled
                                    >
                                        <FilePdfOutlined />Etiqueta
                                    </Button>}
                                </Space>
                            }}
                        />
                    </Table>
                    <Modal
                        title="Tarjeta en PDF"
                        style={{
                            minWidth: 890,
                            minHeight: 600,
                        }}
                        visible={isModalOpen}
                        onOk={() => setIsModalOpen(false)}
                        onCancel={() => setIsModalOpen(false)}
                        okText="OK"
                        cancelText="Cancelar"
                    >
                        {message && <PDFViewer style={{
                            width: '100%',
                            height: '100%',
                            minWidth: 800,
                            minHeight: 600,
                        }}>
                            <PDFExport message={message} />
                        </PDFViewer>}
                    </Modal>
                </div>
            </div>
        </div>
    )
}

const ButtonExcel = ({ order, disabled }: { order: OrderRow, disabled: boolean }) => {
    const [loading, setLoading] = useState(false)
    const { token } = useSelector((state: any) => state)

    const downloadExcel = async () => {
        if (!loading) {
            setLoading(true)
            axios({
                method: 'get',
                url: `https://app.bodegaenlinea.cl/api/v3/sync/order/${order.orderId}/xlsx`,
                responseType: 'blob',
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then((response) => {
                let stringDate = "" + new Date().getFullYear() + pad(new Date().getMonth() + 1, 2) + pad(new Date().getDate(), 2);
                // @ts-ignore
                if (!window.navigator.msSaveOrOpenBlob) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', stringDate + ' eOrder ' + order.orderId + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                } else {
                    // @ts-ignore
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), stringDate + ' eOrder ' + order.orderId + '.xlsx');
                }
                setLoading(false)
            }).catch((err) => {
                alert(err)
                console.log(err)
                setLoading(false)
            })
        }
    }

    return <Button disabled size='small' type={undefined} onClick={downloadExcel} loading={loading} icon={<FileExcelOutlined />}>
        Excel
    </Button>
}

Font.register({ family: 'ABChanel PB SemiBold S', src: ChanelFont })
Font.registerHyphenationCallback(word => [word])

// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#FFF',
        fontFamily: 'ABChanel PB SemiBold S',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    section: {
        margin: 10,
        marginHorizontal: 20,
        padding: 10,
        flexGrow: 1,
        textAlign: 'center',
        textOverflow: 'ellipsis',
    }
});


/* A4 210, 297 */
/* A4 595.28, 841.89 */
/* La tasa es MM / 0,352775165 */

/* Tarjeta es 90, 125 */
/* Tarjeta es 254, 355.6 */
/* La tasa es MM / 0,352775165 */

const K = 0.352775165

// Create Document Component
const PDFExport = ({ message }: { message: string }) => (
    <Document>

        <Page size={{
            width: 90 / K,
            height: 125 / K
        }} style={styles.page} orientation='landscape'>
            <View style={styles.section}>
                {/* style={styles.text} wrap={true} */}
                <Text>{message}</Text>
            </View>
        </Page>
    </Document>
);

export default Orders